// src/utils/constants.js
export const MAX_URLS = 20000;
export const URL_LIMIT_ERROR = `CSV file cannot contain more than ${MAX_URLS.toLocaleString()} URLs.`;